import React from "react"
import { colorCode } from "../../functions/middle-category-style"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { Link, navigate } from "gatsby"

export default function NoteList({ data }) {

  const handleCardClick = (url, e) => {

    e.stopPropagation();

    // クリックされた要素が a タグでない場合、記事カードのリンク先に遷移
    if (e.target.tagName.toLowerCase() !== 'a') {
      navigate(url);
    }
  };

  return (
    <>
      <div className="flex_wrap note_box">
        {data.map(({ node }) => (
          <div key={node.notesId} className="flex_contents" onClick={(e) => handleCardClick(`/note/${node.notesId}`, e)}>

            <div className="contents_box sp_scroll_x">
                <LazyAndPreloadImage imgUrl={node.thumbnail ? node.thumbnail.url : ''} alt={"ノート一覧"} />
            </div>

            <div className="caption_box">
              { node.middle_category ?
                
                <div className="culture_icon column_icon case_study_icon single" style={{background: colorCode(node.middle_category.display_color ? node.middle_category.display_color[0] : '')}}>
                  <Link to={'/note/category/' + node.middle_category.name}>{node.middle_category.name}</Link>
                </div>
                
                : ''
              }

              <Link to={'/note/' + node.notesId}>
                <div className="note_category_title">{node.title}</div>
              </Link>

              <ul className="tag_list">
                {node.tags.map((tag) => (
                  tag.type[0] === "ノートタグ" ?
                    <li key={tag.id}><Link to={'/note/tag/' + tag.name}>#{tag.name}</Link></li>
                  : ''
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
